import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { useUserRights } from "../../../contexts/UserRightsContext";
import WagerLimitsBooks from "./WagerLimitsBooks";
import WagerLimitsSettings from "./WagerLimitsSettings";
import "./WagerLimitsTabs.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index || props.hidden}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function WagerLimitsTabs(props) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  //const user = useContext(UserContext);
  console.log("", props);
  return (
    <React.Fragment>
      <Tabs value={value} onChange={handleChange} className="tabs-class">
        <Tab label="General" {...a11yProps(0)} hidden={!hasRights(470)} />
        <Tab label="Books" {...a11yProps(1)} hidden={!hasRights(471)} />
      </Tabs>
      <hr className="my-2" />
      <TabPanel
        className="tab-content cell-top-align"
        value={value}
        index={0}
        hidden={!hasRights(470)}
      >
        <WagerLimitsSettings
          WagerLimit={props.WagerLimit}
          UpdateWagerLimit={props.WagerLimit}
        ></WagerLimitsSettings>
      </TabPanel>
      <TabPanel
        className="tab-content cell-top-align"
        value={value}
        index={1}
        hidden={!hasRights(471)}
      >
        <WagerLimitsBooks WagerLimit={props.WagerLimit}></WagerLimitsBooks>
      </TabPanel>
    </React.Fragment>
  );
}
